let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b4iDC")).then(() => parcelRequire('aR7pU'));